import { transformHotkeysToEngineRules } from './rule-transforms';
import { isPartialMatch, isCompleteMatch } from './rule-matching';
import { runHandlerPipeline } from './handler-pipeline';
import { logger } from './logger';

let clearBufferTimeout = null;

const runTheEngine = (engineRules, inputBuffer, onSuccess) => {
  const matchingRules = engineRules.filter((rule) => isPartialMatch(inputBuffer, rule));
  const hasPartialMatches = matchingRules.length > 0;

  const clearBufferWhileKeepingReference = () => {
    inputBuffer.splice(0, inputBuffer.length);
  };

  if (clearBufferTimeout) {
    clearTimeout(clearBufferTimeout);
  }

  clearBufferTimeout = setTimeout(clearBufferWhileKeepingReference, 2000);

  if (hasPartialMatches) {
    logger.log('Partial matches found. Rules: ', matchingRules, ' Buffer: ', inputBuffer);

    const completeMatches = matchingRules.filter((rule) => isCompleteMatch(inputBuffer, rule));
    const hasCompleteMatch = completeMatches.length > 0;

    if (hasCompleteMatch) {
      const latestEvent = inputBuffer.slice(-1)[0].eventReference;
      latestEvent.preventDefault();

      logger.log('Complete matches found. Rules: ', completeMatches, ' Buffer: ', inputBuffer);

      let shouldClearBuffer = true;

      completeMatches.forEach((rule) => {
        runHandlerPipeline(rule, inputBuffer, latestEvent, onSuccess);

        const hotkey = rule.hotkeyReference;

        shouldClearBuffer = shouldClearBuffer && !hotkey.doNotClearBufferOnCompleteMatch;
      });

      if (shouldClearBuffer) {
        clearBufferWhileKeepingReference();
      }

      clearTimeout(clearBufferTimeout);
    }

    return;
  }

  logger.log('No matches found. Buffer: ', inputBuffer);

  inputBuffer.shift();

  if (inputBuffer.length > 0) {
    runTheEngine(engineRules, inputBuffer, onSuccess);
  }
};

export const hotkeyService = {
  execute(inputBuffer, activeHotkeys, onSuccess) {
    const engineRules = activeHotkeys.reduce(transformHotkeysToEngineRules, []);

    runTheEngine(engineRules, inputBuffer, onSuccess);
  },
};
